import React from 'react'
import './header.css'
import LOGO from '../../assets/images/logo.svg'

const Header = () => {

  return (
    <header>
      <div className="header__container">
        <div className="me">
          <div className="logo"><img src={LOGO} alt="Logo" /></div>
          <div className="name-title">
            <h1>Julio Vargas</h1>
            <div className="divider"></div>
            <h5 className="text-light">Front End Web Developer</h5>
          </div>
        </div>

      </div>

    </header>
  )
}

export default Header